@if (
  {
    product: product$ | async,
    reviews: reviews$ | async,
    relatedProducts: relatedProducts$ | async,
    upSellProducts: upSellProducts$ | async,
    crossSellProducts: crossSellProducts$ | async,
    recentlyViewedProducts: recentlyViewedProducts$ | async,
    productBlockLength: productBlockLength$ | async,
  };
  as data
) {
  @if (data.product) {
    <div class="container container-product">
      <div class="row">
        <div class="col-12">
          <app-breadcrumbs></app-breadcrumbs>
        </div>
      </div>
      <div class="product-main-row">
        <div class="col-product-media">
          <!-- @if (isBrowserMode()) { -->
          <div class="product-media-holder">
            <ngx-gallery
              #gallery
              [options]="galleryOptions"
              [images]="galleryImages"
            ></ngx-gallery>
            @if (data.product.discountPercent) {
              <span class="price-discount">
                <span class="badge badge-secondary">%</span>
              </span>
            }
          </div>
          <!-- } -->
        </div>
        <div class="col-product-data">
          <div class="h-100">
            <div class="col-product">
              <div class="product-data">
                <div class="page-title-wrapper">
                  <h1 class="page-title" id="product-id-{{ data.product.entity_id }}">
                    @switch (data.product.type_id) {
                      @case (ProductType.Bundle) {
                        <span [innerHtml]="data.product.name[0]"></span>
                      }
                      @default {
                        <span [innerHtml]="data.product.name"></span>
                      }
                    }
                  </h1>
                  <div
                    class="page-title-wrapper__icon-container"
                    (click)="addProductToWishList(data.product.entity_id)"
                  >
                    @if (!wishListLoading) {
                      <mat-icon
                        class="page-title-wrapper__icon"
                        svgIcon="heart-outline"
                      ></mat-icon>
                    }
                    @if (wishListLoading) {
                      <mat-spinner diameter="24" class="product-spinner"> </mat-spinner>
                    }
                  </div>
                </div>
                <div class="product-sku">
                  <span translate>Product Code</span>:
                  {{ data.product.sku }}
                </div>
                @switch (data.product.type_id) {
                  @case (ProductType.Bundle) {
                    <div class="product-price">
                      <span class="regular-price">
                        <app-currency></app-currency>
                        <app-price
                          [price]="productPriceBundled || data.product.finalPrice"
                        ></app-price>
                      </span>
                    </div>
                  }
                  @default {
                    <div class="product-price">
                      <span
                        [ngClass]="
                          data.product.is_discount ? 'special-price' : 'regular-price'
                        "
                      >
                        <app-currency></app-currency>
                        <app-price [price]="data.product.finalPrice"></app-price>
                      </span>
                      @if (data.product.is_discount) {
                        <span class="original-price">
                          <app-currency></app-currency>
                          <app-price [price]="data.product.regularPrice"></app-price>
                        </span>
                      }
                      <!-- <span class="price-discount" *ngIf="data.product.discountPercent">
                      <span class="text-secondary">
                        {{ data.product.discountPercent }}%
                      </span>
                    </span> -->
                    </div>
                  }
                }
                @if (isCalculatorVisible) {
                  <div class="product-calculator">
                    <mat-accordion>
                      <mat-expansion-panel
                        (opened)="calculatorOpenState = true"
                        (closed)="calculatorOpenState = false"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <img
                              loading="lazy"
                              src="assets/images/leasing-calculator/calculator-icon.png"
                              alt="{{ 'Calculate' | translate | async }}"
                              srcset
                            />
                            <span translate>Calculate the installment amount</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (calculatorOpenState) {
                          <app-leasing-calculator
                            [productPrice]="data.product.finalPrice"
                            [isTFbankVisible]="isTFbankVisible"
                            [isLhvVisible]="isLhvVisible"
                            [isEstoVisible]="isEstoVisible"
                            [isInbankVisible]="isInbankVisible"
                          ></app-leasing-calculator>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                }
                @if (data.product.short_description) {
                  <div
                    class="product-short-description"
                    [innerHtml]="data.product.short_description"
                  ></div>
                }
                @switch (data.product.type_id) {
                  @case (ProductType.Configurable) {
                    <app-configurable
                      class="lg"
                      [product]="data.product"
                      (optionChanged)="optionChanged(data.product, $event)"
                      #configurableComponent
                    />
                  }
                  @case (ProductType.Bundle) {
                    <app-bundle-options
                      #bundleComponent
                      [options]="data.product.bundle_options_data.options"
                      (optionsChanged)="bundledOptionsChanged($event)"
                    />
                  }
                }
                <app-product-stock-options
                  [salableQty]="data.product.salable_qty"
                  [isInStock]="data.product.stock?.is_in_stock!"
                  [stockText]="
                    productStockService.isProductOutOfStock(data.product)
                      ? 'Out of stock'
                      : 'In stock'
                  "
                />
                <div class="add-to-cart">
                  @if (!productStockService.isProductOutOfStock(data.product)) {
                    <app-speedy-qty
                      class="group-qty"
                      [qty]="qty"
                      (qtyChange)="changeQty($event, data.product)"
                    />
                  }
                  <app-speedy-button
                    [loading]="loading"
                    [loadingSuccess]="loadingSuccess"
                    [disabled]="productStockService.isProductOutOfStock(data.product)"
                    text="Add to cart"
                    iconPrefix="basket-plus-outline"
                    (clicked)="addToCart(data.product)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (mediaDetails.length > 0) {
        <div class="video-wrap">
          @for (mediaItem of mediaDetails; track mediaItem) {
            <div class="video-wrap__item">
              @if (
                mediaItem.media_type === 'external-video' &&
                mediaItem.resource === 'youtube'
              ) {
                <iframe
                  id="ytplayer"
                  type="text/html"
                  width="100"
                  height="100"
                  [src]="mediaItem?.embededUrl"
                  frameborder="0"
                  allowfullscreen
                >
                </iframe>
              }
              @if (
                mediaItem.media_type === 'external-video' &&
                mediaItem.resource === 'vimeo'
              ) {
                <iframe
                  [src]="mediaItem?.embededUrl"
                  width="100"
                  height="100"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                >
                </iframe>
              }
            </div>
          }
        </div>
      }
      <speedy-product-description [product]="data.product"></speedy-product-description>
      <div class="reviews-and-comments">
        <div class="block-title">
          <h2 class="block-title__text" translate>Reviews</h2>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12 reviews-and-comments__list">
            <app-reviews-list [reviews]="data.reviews!"></app-reviews-list>
          </div>
          <div class="col-md-6 col-xs-12 reviews-and-comments__form">
            <app-reviews-form
              [productId]="data.product.id"
              (reviewAdded)="reviewAdded$.next()"
            ></app-reviews-form>
          </div>
        </div>
      </div>
      @if (data.upSellProducts?.length) {
        <app-products-slider
          className="upsell-products"
          title="Up-sell products"
          [products]="data.upSellProducts!"
          [sliderConfig]="upSellProductsConfig"
        >
        </app-products-slider>
      }
      @if (data.crossSellProducts?.length) {
        <app-products-slider
          className="cross-sell-products"
          title="Cross-sell products"
          [products]="data.crossSellProducts!"
          [sliderConfig]="crossSellProductsConfig"
        >
        </app-products-slider>
      }
      @if (data.relatedProducts?.length) {
        <app-products-slider
          className="related-products"
          title="Related products"
          [products]="data.relatedProducts!"
          [sliderConfig]="relatedProductsConfig"
        >
        </app-products-slider>
      }
      @if (data.recentlyViewedProducts?.length) {
        <app-products-slider
          className="last-viewed"
          title="Last viewed products"
          [products]="data.recentlyViewedProducts!"
          [sliderConfig]="productsRecentlyViewedConfig"
        >
        </app-products-slider>
      }
      <app-blocks-grid
        [countToShow]="data.productBlockLength || blockIdentifiers.length"
        [blockRows]="data.productBlockLength / 2 || 2"
        [blockIdentifiers]="blockIdentifiers"
      ></app-blocks-grid>
    </div>
  }
  <!-- <ngx-json-ld [json]="schema"></ngx-json-ld> -->
}
